// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminTab_container__2J8Qz","listContainer":"AdminTab_listContainer__2Cmio"};